export const ownsChatMessage = (message, actorId) => Boolean(
  actorId && message?.id && message?.sender_id === actorId
  && !message.deleted && !String(message.id).startsWith('temp_')
);
